import Vue from 'vue'

export const createVM = function (components) {
  if (typeof document === 'undefined') {
    return console.error('plugin cannot be used in ssr.')
  }
  const Ctor = Vue.extend(components)
  const $vm = new Ctor({
    el: document.createElement('div')
  })
  document.body.appendChild($vm.$el)
  return $vm
}



// WEBPACK FOOTER //
// ./src/components/alert/createVM.js